import { render, staticRenderFns } from "./PhotoControl.vue?vue&type=template&id=3fedca80&"
import script from "./PhotoControl.vue?vue&type=script&lang=js&"
export * from "./PhotoControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports